<div class="loading-container">
  <div class="load-wrapper">
    <img src="assets/icons/ic-loading@3x.svg" alt="loading" />
    <ng-content select="[body]"></ng-content>
  </div>
</div>
